module.exports = __webpack_public_path__ + "static/media/fake.c4b4e3a2.jpg";